import {
  addAllLabels,
  removeAllLabels,
  updateSelectedLabels,
} from "redux/Modals/actions";
import { useDispatch } from "react-redux";
import { Fragment, useState } from "react";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { IoMdInformationCircleOutline } from "react-icons/io";

import styles from "./style.module.scss";
import classNames from "classnames";

const SingleRow = ({ singleLabel, selectedLabels, uniquenessScores }: any) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const dispatch = useDispatch();

  const selectionCount = selectedLabels.filter((selectedLabel: any) =>
    singleLabel.labels.some(
      (label: any) => selectedLabel.id === label.id && selectedLabel.selected
    )
  ).length;

  const handleTriggerClick = () => {
    setIsExpanded(!isExpanded);
  };

  const handleLabelSelection = (
    labelID: string,
    boundingBox: number[],
    color: string
  ) => {
    dispatch(
      updateSelectedLabels(
        labelID,
        boundingBox,
        color,
        singleLabel.categoryName
      ) as any
    );
  };

  const selectAllLabels = () => {
    dispatch(addAllLabels(singleLabel.labels) as any);
  };

  const hideAllLabels = () => {
    dispatch(removeAllLabels(singleLabel.labels) as any);
  };

  const renderSubLabelInfo = (subLabel: any, index: number) => {
    const uniquenessScore: number | null =
      uniquenessScores.find((item: any) => item.objectId === subLabel.id)
        ?.uniquenessScore || null;

    if (!subLabel.id) {
      return <noscript />;
    }

    let objectSizeLine = <noscript />;
    let uniquenessScoreLine = <noscript />;

    if (subLabel.bounding_box) {
      const [, , width, height] = subLabel.bounding_box;
      const objectSizeText = `${height}x${width}`;

      objectSizeLine = <span>{`object_size: ${objectSizeText}`}</span>;
    }

    if (typeof uniquenessScore === "number") {
      uniquenessScoreLine = (
        <span>{`uniqueness_score: ${uniquenessScore}`}</span>
      );
    }

    const content = (
      <div className={styles.objectToolTipTextContainer}>
        <span>{`object_id: ${subLabel.id}`}</span>
        {objectSizeLine}
        {uniquenessScoreLine}
      </div>
    );

    return (
      <div
        className={styles.infoIcon}
        onClick={(e) => e.stopPropagation()}
        data-tooltip-id={"image-details-object-info-tooltip" + index}
      >
        <IoMdInformationCircleOutline size="16px" />
        <TooltipWrapper
          maxWidth="max-content"
          id={"image-details-object-info-tooltip" + index}
          content={content}
        />
      </div>
    );
  };

  return (
    <Fragment>
      <div className={styles.singleLableRow}>
        <span
          className={styles.objectLabel}
          style={{ color: singleLabel.color }}
          onClick={handleTriggerClick}
        >
          {singleLabel?.categoryName}{" "}
          {`(${selectionCount}/${singleLabel?.labels?.length})`}
        </span>
        <div className={styles.actionButtons}>
          <span className={styles.linkButton} onClick={selectAllLabels}>
            Show All
          </span>
          <span className={styles.linkButton} onClick={hideAllLabels}>
            Hide All
          </span>
          <div className={styles.triggerIcon} onClick={handleTriggerClick}>
            {isExpanded ? (
              <BiChevronUp size="1.55em" />
            ) : (
              <BiChevronDown size="1.55em" />
            )}
          </div>
        </div>
      </div>
      {isExpanded && (
        <div className={styles.subRows}>
          {singleLabel?.labels?.map((subLabel: any, index: number) => {
            const subLabelID = subLabel.id;
            const subLabelDisplayNumber = index + 1;
            const isSubIDSelected = selectedLabels?.some(
              (label: any) => label.id === subLabelID && label.selected
            );

            const subLabelClassNames = classNames(styles.subLabel, {
              [styles.greyColorText]: !isSubIDSelected,
            });

            return (
              <div
                className={styles.singleLableRow}
                key={index}
                onClick={() =>
                  handleLabelSelection(
                    subLabel.id,
                    subLabel.bounding_box,
                    singleLabel.color
                  )
                }
              >
                <span className={subLabelClassNames}>
                  {subLabel?.category_display_name} {subLabelDisplayNumber}
                  {renderSubLabelInfo(subLabel, index)}
                </span>

                <div className={styles.viewLabelButton}>
                  {isSubIDSelected ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="13"
                      viewBox="0 0 19 13"
                      fill="none"
                    >
                      <path
                        d="M9.5 10.4C10.5795 10.4 11.4972 10.0208 12.2528 9.2625C13.0085 8.50417 13.3864 7.58333 13.3864 6.5C13.3864 5.41667 13.0085 4.49583 12.2528 3.7375C11.4972 2.97917 10.5795 2.6 9.5 2.6C8.42045 2.6 7.50284 2.97917 6.74716 3.7375C5.99148 4.49583 5.61364 5.41667 5.61364 6.5C5.61364 7.58333 5.99148 8.50417 6.74716 9.2625C7.50284 10.0208 8.42045 10.4 9.5 10.4ZM9.5 8.84C8.85227 8.84 8.30171 8.6125 7.8483 8.1575C7.39489 7.7025 7.16818 7.15 7.16818 6.5C7.16818 5.85 7.39489 5.2975 7.8483 4.8425C8.30171 4.3875 8.85227 4.16 9.5 4.16C10.1477 4.16 10.6983 4.3875 11.1517 4.8425C11.6051 5.2975 11.8318 5.85 11.8318 6.5C11.8318 7.15 11.6051 7.7025 11.1517 8.1575C10.6983 8.6125 10.1477 8.84 9.5 8.84ZM9.5 13C7.39848 13 5.48409 12.4114 3.75682 11.2342C2.02955 10.0569 0.777273 8.47889 0 6.5C0.777273 4.52111 2.02955 2.94306 3.75682 1.76583C5.48409 0.588611 7.39848 0 9.5 0C11.6015 0 13.5159 0.588611 15.2432 1.76583C16.9705 2.94306 18.2227 4.52111 19 6.5C18.2227 8.47889 16.9705 10.0569 15.2432 11.2342C13.5159 12.4114 11.6015 13 9.5 13ZM9.5 11.2667C11.1265 11.2667 12.6199 10.8369 13.9801 9.9775C15.3403 9.11806 16.3803 7.95889 17.1 6.5C16.3803 5.04111 15.3403 3.88194 13.9801 3.0225C12.6199 2.16306 11.1265 1.73333 9.5 1.73333C7.87349 1.73333 6.38011 2.16306 5.01989 3.0225C3.65966 3.88194 2.6197 5.04111 1.9 6.5C2.6197 7.95889 3.65966 9.11806 5.01989 9.9775C6.38011 10.8369 7.87349 11.2667 9.5 11.2667Z"
                        fill="currentColor"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="17"
                      viewBox="0 0 19 17"
                      fill="none"
                    >
                      <path
                        d="M13.0409 9.01515L11.7886 7.7702C11.9182 7.09764 11.7239 6.46801 11.2057 5.88131C10.6875 5.29461 10.0182 5.06566 9.19773 5.19444L7.94545 3.9495C8.19015 3.83502 8.43845 3.74916 8.69034 3.69192C8.94223 3.63468 9.21212 3.60606 9.5 3.60606C10.5795 3.60606 11.4972 3.98169 12.2528 4.73295C13.0085 5.48422 13.3864 6.39646 13.3864 7.4697C13.3864 7.75589 13.3576 8.0242 13.3 8.27462C13.2424 8.52504 13.1561 8.77189 13.0409 9.01515ZM15.8045 11.7197L14.5523 10.5177C15.0992 10.1027 15.585 9.64836 16.0097 9.15467C16.4343 8.66099 16.7977 8.09933 17.1 7.4697C16.3803 6.02441 15.3475 4.87605 14.0017 4.02462C12.6559 3.17319 11.1553 2.74747 9.5 2.74747C9.08258 2.74747 8.67235 2.77609 8.26932 2.83333C7.86629 2.89057 7.47045 2.97643 7.08182 3.09091L5.74318 1.7601C6.33333 1.51684 6.93788 1.33439 7.55682 1.21275C8.17576 1.09112 8.82349 1.0303 9.5 1.0303C11.6735 1.0303 13.6095 1.62774 15.308 2.8226C17.0064 4.01747 18.2371 5.5665 19 7.4697C18.6689 8.31397 18.2335 9.09743 17.6938 9.82008C17.154 10.5427 16.5242 11.1759 15.8045 11.7197ZM16.2364 17L12.6091 13.4369C12.1053 13.5943 11.5979 13.7123 11.0869 13.791C10.5759 13.8697 10.047 13.9091 9.5 13.9091C7.32652 13.9091 5.39053 13.3117 3.69205 12.1168C1.99356 10.9219 0.762879 9.3729 0 7.4697C0.302273 6.71128 0.683712 6.00652 1.14432 5.35543C1.60492 4.70434 2.1303 4.12121 2.72045 3.60606L0.345455 1.20202L1.55455 0L17.4455 15.798L16.2364 17ZM3.92955 4.80808C3.51212 5.18013 3.13068 5.58796 2.78523 6.03157C2.43977 6.47517 2.1447 6.95455 1.9 7.4697C2.6197 8.91498 3.65246 10.0633 4.9983 10.9148C6.34413 11.7662 7.8447 12.1919 9.5 12.1919C9.78788 12.1919 10.0686 12.174 10.342 12.1383C10.6155 12.1025 10.8962 12.0631 11.1841 12.0202L10.4068 11.2045C10.2485 11.2475 10.0973 11.2797 9.95341 11.3011C9.80947 11.3226 9.65833 11.3333 9.5 11.3333C8.42045 11.3333 7.50284 10.9577 6.74716 10.2064C5.99148 9.45518 5.61364 8.54293 5.61364 7.4697C5.61364 7.31229 5.62443 7.16204 5.64602 7.01894C5.66761 6.87584 5.7 6.72559 5.74318 6.56818L3.92955 4.80808Z"
                        fill="currentColor"
                      />
                    </svg>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Fragment>
  );
};

const ObjectsBox = ({ selectedLabels, labels, uniquenessScores }: any) => {
  return (
    <div className={styles.objectsContainer}>
      {labels.map((singleLabel: any, index: number) => (
        <SingleRow
          key={index}
          singleLabel={singleLabel}
          selectedLabels={selectedLabels}
          uniquenessScores={uniquenessScores}
        />
      ))}
    </div>
  );
};

export default ObjectsBox;
